import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Space } from 'antd';
import moment from 'moment';
import React, { useEffect } from 'react';
import DrawerForm from './DrawerForm';
import TableWithActions from './TableWithActions';

interface BatchSectionProps {
  data: any[];
  visible: boolean;
  editingRecord: any;
  onEdit: (record: any) => void;
  onDelete: (key: string) => void;
  onSubmit: (values: any) => void;
  onClose: () => void;
  disabled?: boolean;
}

const BatchSection: React.FC<BatchSectionProps> = ({
  data,
  visible,
  editingRecord,
  onEdit,
  onDelete,
  onSubmit,
  onClose,
  disabled,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (editingRecord) {
      const recordWithMomentDate = {
        ...editingRecord,
        expiration: editingRecord.expiration
          ? moment(editingRecord.expiration, 'DD-MM-YYYY')
          : null,
      };
      form.setFieldsValue(recordWithMomentDate);
    } else {
      form.resetFields();
    }
  }, [editingRecord, form]);

  const handleSubmit = (values: any) => {
    const valuesWithFormattedDate = {
      ...values,
      expiration: values.expiration ? values.expiration.format('DD-MM-YYYY') : null,
    };
    onSubmit(valuesWithFormattedDate);
    form.resetFields();
  };

  return (
    <div>
      <Space
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
        }}
      >
        <h3>Batch/Lot #</h3>
        {/* Toggle Add/Edit Button */}
        <Button
          type="primary"
          icon={data.length > 0 ? <EditOutlined /> : <PlusOutlined />}
          onClick={() => {
            if (data.length > 0) {
              onEdit(data[0]); // Edit the first batch
            } else {
              onEdit(null); // Add a new batch
            }
          }}
          disabled={disabled}
        >
          {data.length > 0 ? 'Edit Batch' : 'Add Batch'}
        </Button>
      </Space>
      <TableWithActions
        columns={[
          { title: 'Batch #', dataIndex: 'batch', key: 'batch' },
          { title: 'Expiration Date', dataIndex: 'expiration', key: 'expiration' },
          { title: 'Notes', dataIndex: 'notes', key: 'notes' },
        ]}
        data={data}
        onEdit={onEdit}
        onDelete={onDelete}
      />
      <DrawerForm
        visible={visible}
        title={editingRecord ? 'Edit Batch' : 'Add Batch'}
        form={form}
        onClose={onClose}
        onSubmit={handleSubmit}
        fields={[
          { name: 'batch', label: 'Batch #', type: 'input', rules: [{ required: true }] },
          {
            name: 'expiration',
            label: 'Expiration Date',
            type: 'date'
          },
          { name: 'notes', label: 'Notes', type: 'textarea' },
        ]}
      />
    </div>
  );
};

export default BatchSection;
